import { Box } from '@interxfi/design-system/components/box/box';
import { Drawer, type DrawerProps } from '@interxfi/design-system/components/dialog/drawer/drawer';
import { InfoList, type InfoListItem } from '@interxfi/design-system/components/list/info/info-list';
import type { ResponsiveBoxSizing, SpaceUnit } from '@interxfi/design-system/util';
import { IxcRegistrationV1Purpose } from '@interxfi/types';
import { AccountPurposeIcon } from './account-purpose-icon';

const BOX_PADDING = {
  left: { sm: '0px', md: '32px' },
  right: { sm: '0px', md: '32px' },
  top: '16px',
  bottom: '16px',
} as const satisfies ResponsiveBoxSizing<SpaceUnit>;

const descriptions = [
  {
    id: IxcRegistrationV1Purpose.AveragePrice,
    icon: <AccountPurposeIcon purpose={IxcRegistrationV1Purpose.AveragePrice} />,
    title: 'Average Price',
    description: 'Used to support batch order allocations across a number of customer brokerage accounts.',
  },
  {
    id: IxcRegistrationV1Purpose.Settlement,
    icon: <AccountPurposeIcon purpose={IxcRegistrationV1Purpose.Settlement} />,
    title: 'Settlement',
    description: 'Used if the Program is net settling customers’ activity on an aggregated basis with one fund transfer each day.',
  },
  {
    id: IxcRegistrationV1Purpose.Billing,
    icon: <AccountPurposeIcon purpose={IxcRegistrationV1Purpose.Billing} />,
    title: 'Billing',
    description: 'Credits to this account come from billing customer brokerage accounts. Debits occur when fees are owed to Interchange.',
  },
  {
    id: IxcRegistrationV1Purpose.TradeError,
    icon: <AccountPurposeIcon purpose={IxcRegistrationV1Purpose.TradeError} />,
    title: 'Trade Error',
    description: 'Acts as the contra-account to trades that are either reversed out of a brokerage account or executed “as of”.',
  },
  {
    id: IxcRegistrationV1Purpose.Inventory,
    icon: <AccountPurposeIcon purpose={IxcRegistrationV1Purpose.Inventory} />,
    title: 'Inventory',
    description: 'Used to facilitate things like batch/allocated orders, free awards of stock, or a robo-advisor rebalancing engine.',
  },
  {
    id: IxcRegistrationV1Purpose.Deposit,
    icon: <AccountPurposeIcon purpose={IxcRegistrationV1Purpose.Deposit} />,
    title: 'Deposit',
    description:
      'An account to hold and manage the clearing deposit that covers obligations arising from the clearance of customer brokerage accounts.',
  },
] as const satisfies InfoListItem[];

export function CorrespondentAccountDescriptionDrawer(props: Omit<DrawerProps, 'description' | 'title'>) {
  return (
    <Drawer description="More information about Correspondent Accounts" title="Correspondent Accounts" {...props}>
      <Box padding={BOX_PADDING}>
        <InfoList items={descriptions} />
      </Box>
    </Drawer>
  );
}
